import { Bike } from 'lucide-react';

export const AddressServiceabilityResponseUI = ({ addressServiceability }) => {
  if (!addressServiceability) return null;

  return (
    <div className='tw-mb-4'>
      <div className='tw-text-400 tw-font-medium tw-mb-3 tw-flex tw-items-center tw-gap-2'>
        <Bike size={18} />
        Serviceability Status
      </div>
      <div
        className={`tw-py-5 tw-px-5  tw-border-solid tw-rounded-2xl tw-border-[1px] ${
          addressServiceability.isServiceable
            ? 'tw-border-green-200 tw-bg-green-100/80 tw-text-base-green'
            : 'tw-border-red-200 tw-bg-red-100/50 tw-text-red-600'
        }  tw-text-300 tw-flex tw-flex-col tw-gap-2`}
      >
        <div className='tw-flex tw-flex-col tw-items-start'>
          <div className='tw-text-[1.4rem] tw-capitalize tw-whitespace-nowrap tw-font-normal'>
            This address is
            <span
              className={`tw-text-[1.5rem] tw-font-medium ${
                addressServiceability.isServiceable
                  ? 'tw-text-base-green tw-mr-1'
                  : 'tw-text-red-600 tw-mx-1'
              }`}
            >
              {addressServiceability.isServiceable ? '' : 'not'}
            </span>
            <div className='tw-font-medium tw-text-[1.5rem]'>serviceable.</div>
          </div>
          {addressServiceability.distance && (
            <div
              className={`tw-rounded-full tw-px-4 tw-py-2 ${
                addressServiceability.isServiceable
                  ? 'tw-bg-green-200'
                  : 'tw-bg-red-200'
              } tw-my-4 tw-font-medium`}
              data-dd-privacy='mask'
            >
              {addressServiceability.distance} KMs away
            </div>
          )}
        </div>
        {addressServiceability.reason && (
          <div className='tw-flex tw-flex-col tw-items-start tw-bg-white tw-p-4 tw-rounded-2xl tw-font-[1.2rem]'>
            <div className='tw-font-medium'>Reason</div>
            <div className='tw-font-normal'>{addressServiceability.reason}</div>
          </div>
        )}
      </div>
    </div>
  );
};
